import React, { useState } from 'react';
import logo from '../../assets/LettyAI.svg'


const Navbar = () => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);


    return (
        <div className="">
            <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
                <div className="relative flex items-center justify-between">
                    <div className="flex items-center">
                        <p
                            aria-label="Candid Captures"
                            title="Candid Captures"
                            className="inline-flex items-center mr-8"
                        >
                            <img className='w-[10rem] h-[87px] rounded-xl' src={logo} alt="" />

                        </p>

                    </div>

                    <ul className="flex items-center hidden space-x-8 lg:flex">

                        <li>
                            <p
                                aria-label="HOME"
                                title="HOME"
                                className="font-medium tracking-wide text-white transition-colors duration-200 hover:text-teal-accent-400"
                            >
                                HOME
                            </p>
                        </li>

                        <li>
                            <p

                                aria-label="TEXT 2 IMG"
                                title="TEXT 2 IMG"
                                className="font-medium tracking-wide text-gray-300 transition-colors duration-200 hover:text-teal-accent-400"
                            >
                                TEXT 2 IMG
                            </p>
                        </li>
                        <li>
                            <p

                                aria-label="IMG ENHANCER"
                                title="IMG ENHANCER"
                                className="font-medium tracking-wide text-gray-300  transition-colors duration-200 hover:text-teal-accent-400"
                            >
                                IMG ENHANCER
                            </p>
                        </li>

                        <li>
                            <p

                                aria-label="DASHBOARD"
                                title="DASHBOARD"
                                className="font-medium tracking-wide text-gray-300  transition-colors duration-200 hover:text-teal-accent-400"
                            >
                                DASHBOARD
                            </p>
                        </li>

                        <li>
                            <p

                                aria-label="PROFILE"
                                title="PROFILE"
                                className="font-medium tracking-wide text-gray-300  transition-colors duration-200 hover:text-teal-accent-400"
                            >
                                PROFILE
                            </p>
                        </li>


                        <li>
                            <button
                                className="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-deep-purple-accent-400 bg-[#6E3FF2] hover:bg-[#8c64fa] hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                                aria-label="Logout"
                                title="Logout"
                            >
                                Logout
                            </button>
                        </li>


                    </ul>
                    <div className="lg:hidden">
                        <button
                            aria-label="Open Menu"
                            title="Open Menu"
                            className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline"
                            onClick={() => setIsMenuOpen(true)}
                        >
                            <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                                <path
                                    fill="#FFFFFF"
                                    d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                                />
                                <path
                                    fill="#FFFFFF"
                                    d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                                />
                                <path
                                    fill="#FFFFFF"
                                    d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                                />
                            </svg>
                        </button>
                        {isMenuOpen && (
                            <div className="absolute z-10 top-0 left-0 w-full">
                                <div className="p-5 bg-gray-200 border rounded shadow-sm">
                                    <div className="flex items-center justify-between mb-4">
                                        <div>
                                            <p

                                                aria-label="Candid Captures"
                                                title="Candid Captures"
                                                className="inline-flex items-center"
                                            >

                                                <img className='w-[10rem] h-[87px] rounded-xl' src={logo} alt="" />

                                            </p>
                                        </div>
                                        <div>
                                            <button
                                                aria-label="Close Menu"
                                                title="Close Menu"
                                                className="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                                                onClick={() => setIsMenuOpen(false)}
                                            >
                                                <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                                                    <path
                                                        fill="currentColor"
                                                        d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                                                    />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <nav>
                                        <ul className="space-y-4">
                                            <li>
                                                <p

                                                    aria-label="HOME"
                                                    title="HOME"
                                                    className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                                >
                                                    HOME
                                                </p>
                                            </li>



                                            <li>
                                                <p

                                                    aria-label="TEXT 2 IMG"
                                                    title="TEXT 2 IMG"
                                                    className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                                >
                                                    TEXT 2 IMG
                                                </p>
                                            </li>
                                            <li>
                                                <p

                                                    aria-label="IMG ENHANCER"
                                                    title="IMG ENHANCER"
                                                    className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                                >
                                                    IMG ENHANCER
                                                </p>
                                            </li>

                                            <li>
                                                <p
                                                    aria-label="DASHBOARD"
                                                    title="DASHBOARD"
                                                    className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                                >
                                                    DASHBOARD
                                                </p>
                                            </li>

                                            <li>
                                                <p
                                                    aria-label="PROFILE"
                                                    title="PROFILE"
                                                    className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                                >
                                                    PROFILE
                                                </p>
                                            </li>


                                            <li>
                                                <button
                                                    className="inline-flex items-center justify-center h-12 px-6 font-medium  tracking-wide text-white transition duration-200 rounded shadow-md bg-deep-purple-accent-400 bg-[#6E3FF2] hover:bg-[#8c64fa]hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                                                    aria-label="Logout"
                                                    title="Logout"
                                                >
                                                    Logout
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Navbar;